module.exports = __webpack_public_path__ + "static/media/get-on-google.14312a94.svg";